<div class="chart-options">
    <wbo-bi-chart-option (click)="selectOption(o)" *ngFor="let o of options" [option]="o"></wbo-bi-chart-option>
</div>
